import { Event2EventCategory, EventCategory, GetTimeFromTimestamp, MaterialList } from '@dave/types';
import { MaterialListEntity, MaterialListStatusEnum } from './material-list.entity';


export class Event2EventCategoriesEntity {
    constructor(
        public Id: number = null,
        public EventId: number = null,
        public CategoryId: number = null,
    ) {
    }

    public static EntityName = 'Event2EventCategories';
    public Clone(override: Partial<Event2EventCategoriesEntity> = {}): Event2EventCategoriesEntity {
        const attr = { ...this, ...override };
        return Object.assign(new Event2EventCategoriesEntity(), attr);
    }
}

export function Event2EventCategoriesEntityFromBackend(res: Event2EventCategory): Event2EventCategoriesEntity {

    return new Event2EventCategoriesEntity(
        res.Id && +res.Id,
        res.EventId && +res.EventId,
        res.CategoryId && +res.CategoryId,

    );
}

